import api from './config'

export function getList(
  employer_id,
) {
  return api.post('log/getList', {
    employer_id,
  })
}